import request from '@/utils/request'

export function updateLangLevelCfg(data) {
  return request({
    url: 'api/v1/lang-level/updateLang',
    method: 'post',
    data: data
  })
}

export function getLangLevelCfg(data) {
  return request({
    url: 'api/v1/lang-level/getList',
    method: 'post',
    data: data
  })
}

export function delLangLevelCfg(data) {
  return request({
    url: 'api/v1/lang-level/del',
    method: 'delete',
    data: data
  })
}
export function exportLangLevelCfg() {
  return request({
    url: 'api/v1/lang-level/export',
    method: 'get' })
}

export function importLangLevelCfg(data) {
  return request({
    url: 'api/v1/lang-level/import',
    method: 'post',
    data: data,
    timeout: 100000
  })
}

export function uploadLangLevelCdn(data) {
  return request({
    url: 'api/v1/lang-level/uploadCdn',
    method: 'post',
    data: data,
    timeout: 100000
  })
}
